import authKk from './kk/auth.json'
import badCasesKk from './kk/badcases.json'
import cabinetKk from './kk/cabinet.json'
import footerKK from './kk/footer.json'
import giftKk from './kk/gift.json'
import headerKk from './kk/header.json'
import landingKk from './kk/landing.json'
import offlineClientKk from './kk/offline-client.json'
import otpKk from './kk/otp.json'
import authRu from './ru/auth.json'
import badCasesRu from './ru/badcases.json'
import cabinetRu from './ru/cabinet.json'
import footerRu from './ru/footer.json'
import giftRu from './ru/gift.json'
import headerRu from './ru/header.json'
import landingRu from './ru/landing.json'
import offlineClientRu from './ru/offline-client.json'
import otpRu from './ru/otp.json'
import idnRu from './ru/idn.json'
import idnKk from './kk/idn.json'
import megaActivationLoadingKk from './kk/mega-activation-loading.json'
import megaActivationLoadingRu from './ru/mega-activation-loading.json'

export const kkTranslations = {
  header: headerKk,
  landing: landingKk,
  footer: footerKK,
  auth: authKk,
  otp: otpKk,
  cabinet: cabinetKk,
  offlineClient: offlineClientKk,
  badcases: badCasesKk,
  gift: giftKk,
  idn: idnKk,
  megaActivationLoading: megaActivationLoadingKk
}

export const ruTranslations = {
  header: headerRu,
  landing: landingRu,
  footer: footerRu,
  auth: authRu,
  otp: otpRu,
  cabinet: cabinetRu,
  offlineClient: offlineClientRu,
  badcases: badCasesRu,
  gift: giftRu,
  idn: idnRu,
  megaActivationLoading: megaActivationLoadingRu
}
